import moment from 'moment';
import _ from 'lodash';
import {t} from 'shared/core';
import {groupKeyFor} from './eventGroups';

const CELEBRATION_EMOJI = {
  birthday: 'birthday',
  anniversary: 'tada',
  first_day: 'wave'
};

const PILL_STYLES = {
  time_off_request: 'timeOff',
  holiday: 'holiday',
  birthday: 'celebration',
  anniversary: 'celebration',
  first_day: 'celebration'
};

class CalendarEventViewModel {
  constructor(event) {
    this.rowType = 'event';
    this.key = event.id;
    this.title = event.title;
    this.allDay = !!event.allDay;
    this.type = _.get(event, 'extendedProps.type');
    this.start = moment(event.start);
    this.firstDay = this.start.clone().startOf('day');
    this.end = moment(event.end);
    this.emojiKey = CELEBRATION_EMOJI[this.type];
    this.pillStyle = PILL_STYLES[this.type];
    this.groupKey = groupKeyFor(this.type);
  }

  get timeLabel() {
    return this.start.format(t('components.dates.TIMESTAMP_FORMAT'));
  }

  occursOn(date) {
    return date.isSameOrAfter(this.firstDay) && date.isBefore(this.end);
  }
}

export default CalendarEventViewModel;
